<template>
    <div>
        <template v-if="isCorporation">
            <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                                   :titleLabel="$t('profile.label.corp.real_name')"
                                   :parentScreen="parentScreen">
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="corporationName">{{$t('profile.label.corporation_name')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.corporationName'].$model"
                               id="corporationName"
                               name="corporationName"
                               required
                               maxlength="40"
                               v-convert-halfwidth-to-fullwidth
                               @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.corporationName']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.corporation_name')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="corporationNameKana">{{$t('profile.label.corporation_name_kana')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.corporationNameKana'].$model"
                               id="corporationNameKana"
                               name="corporationNameKana"
                               required
                               maxlength="40"
                               v-special-characters-validator
                               v-convert-kana-word
                               @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.corporationNameKana']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.corporation_name_kana')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                    <div class="col-md-6">
                        <FileInput v-model="$v.fileCorpCustomerName1.$model" name="fileCorpCustomerName1"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCorpCustomerName1">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>

                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <FileInput v-model="$v.fileCorpCustomerName2.$model" name="fileCorpCustomerName2"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCorpCustomerName2">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <FileInput v-model="$v.fileCorpCustomerName3.$model" name="fileCorpCustomerName3"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCorpCustomerName3">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <div :class="this.isParentScreenForceNew? 'col-md-9': 'col-md-12' ">
                        <div class="alert alert-warning">
                            <div>
                                {{$t('profile.label.corpname.after_upload')}}
                                <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                                {{$t('profile.label.after_upload_footer')}}
                            </div>
                            <div>{{$t('profile.label.corpname.after_upload.footer')}}</div>
                        </div>
                    </div>
                </div>
                <template v-if="this.isParentScreenEditProfile">
                    <div class="form-action">
                        <button class="btn btn-sm btn-submit btn-success mr-2"
                                :disabled="isDisabledButtonSubmit && isInvalidFile"
                                :type="this.getButtonType()">
                            {{$t('profile.button.verify')}}
                        </button>
                        <button class="btn btn-default btn-cancel btn-sm"
                                type="button"
                                @click="reverseInput">
                            {{$t('profile.button.cancel')}}
                        </button>
                    </div>
                </template>
            </ForceNewsBlockWrapper>
        </template>

        <!-------------------------------------------------CUSTOMER_INDIV_NAME ------------------------------------------------->

        <template v-if="!isCorporation">
            <ForceNewsBlockWrapper :requireCharacters="requireCharacters" :titleLabel="$t('profile.label.real_name')" :parentScreen="parentScreen">
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="lastName">{{$t('profile.label.last_name')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.lastName'].$model"
                               id="lastName"
                               name="lastName"
                               required maxlength="20"
                               @keyup="handleForceNewEvent"
                               v-convert-halfwidth-to-fullwidth
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.lastName']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.last_name')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="firstName">{{$t('profile.label.first_name')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.firstName'].$model"
                               id="firstName"
                               name="firstName"
                               required maxlength="20"
                               v-convert-halfwidth-to-fullwidth
                               @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.firstName']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.first_name')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="lastNameKana">{{$t('profile.label.last_name_kana')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.lastNameKana'].$model"
                               id="lastNameKana"
                               name="lastNameKana"
                               required
                               maxlength="20"
                               v-special-characters-validator
                               v-convert-kana-word
                               @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.lastNameKana']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.last_name_kana')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" for="firstNameKana">{{$t('profile.label.first_name_kana')}}</label>
                    <div class="col-md-6">
                        <input type="text" class="form-control"
                               v-model="$v.input['amsCustomerDetail.firstNameKana'].$model"
                               id="firstNameKana"
                               name="firstNameKana"
                               required
                               maxlength="20"
                               v-special-characters-validator
                               v-convert-kana-word
                               @keyup="handleForceNewEvent"
                        >
                        <error-messages-block :field="$v.input['amsCustomerDetail.firstNameKana']">
                            <template #required>
                                {{$t('MSG_TRS_NAF_0004_param',{param1 : $t('profile.label.first_name_kana')})}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                    <div class="col-md-6">
                        <FileInput v-model="$v.fileCustomerName1.$model" name="fileCustomerName1"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCustomerName1">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <FileInput v-model="$v.fileCustomerName2.$model" name="fileCustomerName2"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCustomerName2">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-6 offset-md-3">
                        <FileInput v-model="$v.fileCustomerName3.$model" name="fileCustomerName3"
                                   @onChangeFileInput="handleChangeFileInput">
                        </FileInput>
                        <error-messages-block :field="$v.fileCustomerName3">
                            <template #fileTypeValidation>
                                {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                            </template>
                            <template #fileSizeValidation>
                                {{$t('profile.error.file_size')}}
                            </template>
                            <template #fileCustomerNameDuplicateValidation>
                                {{$t('profile.error.file_duplicate')}}
                            </template>
                        </error-messages-block>
                    </div>
                </div>
                <div class="form-group row">
                    <div :class="this.isParentScreenForceNew ? 'col-md-9': 'col-md-12' ">
                        <div class="alert alert-warning">
                            <div>{{$t('profile.label.after_upload.new')}}</div>
                            <div>
                                {{$t('profile.label.after_upload' )}}
                                <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                                {{$t('profile.label.after_upload_footer')}}
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="this.isParentScreenEditProfile">
                    <div class="form-action">
                      <button class="btn btn-sm btn-submit btn-success mr-2"
                              :disabled="isDisabledButtonSubmit && isInvalidFile"
                              :type="this.getButtonType()">
                            {{$t('profile.button.verify')}}
                        </button>
                        <button class="btn btn-default btn-cancel btn-sm"
                                type="button"
                                @click="reverseInput">
                            {{$t('profile.button.cancel')}}
                        </button>
                    </div>
                </template>
            </ForceNewsBlockWrapper>
        </template>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import {required} from 'vuelidate/lib/validators'
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {fileCustomerNameDuplicateValidation, fileSizeValidation, fileTypeValidation} from '@/common/helpers/validation'

export default {
        name: "UpdateCustomerName",
        props: {},
        mixins: [formMixin, forceNewUtil],
        data: function () {
            return {
                fileCorpCustomerName1: null,
                fileCorpCustomerName2: null,
                fileCorpCustomerName3: null,
                fileCustomerName1: null,
                fileCustomerName2: null,
                fileCustomerName3: null,
            }
        },
        computed: {
          isCorporation() {
            return this.$store.state[this.namespace].isCorporation
          },
          SUPPORT_DOCUMENT_URL() {
            return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
          },
          fileUploadExt() {
            return this.$store.state.header.headerInfo.fileUploadExt
          },
          fileTypeExtension() {
            return this.fileUploadExt.toUpperCase();
          },
          isInvalidFile(){
            const {$v} = this;
            if (this.isCorporation) {
              return $v.$anyError || (this.fileCorpCustomerName1 === null && this.fileCorpCustomerName2 === null && this.fileCorpCustomerName3 === null);
            }
            return $v.$anyError || (this.fileCustomerName1 === null && this.fileCustomerName2 === null && this.fileCustomerName3 === null);
          },
        },
        validations() {
            const fileValidator = {
                fileTypeValidation,
                fileSizeValidation,
            };
            if (this.isCorporation) {
                return {
                    input: {
                        'amsCustomerDetail.corporationName': {
                            required
                        },
                        'amsCustomerDetail.corporationNameKana': {
                            required
                        },
                    },
                    fileCorpCustomerName1: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCorpCustomerName1')
                    },
                    fileCorpCustomerName2: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCorpCustomerName2')
                    },
                    fileCorpCustomerName3: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCorpCustomerName3')
                    }
                }
            }
            else {
                return {
                    input: {
                        'amsCustomerDetail.firstName': {
                            required
                        },
                        'amsCustomerDetail.firstNameKana': {
                            required
                        },
                        'amsCustomerDetail.lastName': {
                            required
                        },
                        'amsCustomerDetail.lastNameKana': {
                            required
                        },
                    },
                    fileCustomerName1: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCustomerName1')
                    },
                    fileCustomerName2: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCustomerName2')
                    },
                    fileCustomerName3: {
                        ...fileValidator,
                        fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation('fileCustomerName3')
                    },
                }
            }
        },
        methods: {},

    }
</script>
<style scoped>
    .form-group {
        margin-bottom: 5px;
        padding-bottom: 15px;
    }
</style>

